import React from 'react';
import { NavLink } from 'react-router-dom';
import Routes from '../../../Layout/Routes';
import { STRING, ICONS } from '../../../utils/Constant'
import Tooltip from '@material-ui/core/Tooltip';

const SideNavigation = ({ showPage, mainMenuState }) => (
    <div className={"side-nav card " + (mainMenuState ? "main-menu-large" : "main-menu-small")} id="sideNavDrawer">
        <div id="side-nav-drawer-content">
            <ul className="main-side-menu" id="accordion">
                {window['runTimeData'].ALL_VIEW_LIST !== undefined && window['runTimeData'].ALL_VIEW_LIST.length > 0 &&
                    window['runTimeData'].ALL_VIEW_LIST.includes(window.localStorage.getItem('loginUser')) ?
                    <li onClick={e => showPage(e, STRING.HOME)}>
                        <NavLink className="main-side-a" exact={true} activeClassName="" to={STRING.SEARCH}>
                            <i className={"fa mr-25px " + (ICONS.HOME)} />
                            <span className="side-nav-text">{STRING.HOME}</span>
                        </NavLink>
                    </li>
                    : null}
                <li>
                    <NavLink to={Routes.SEARCH} exact={true} className="main-side-a" activeClassName="kognetics-actice-class" onClick={e => showPage(e, STRING.SEARCH)}>
                        <i className={"fa mr-25px " + (ICONS.SEARCH)} />
                        <span className="side-nav-text">{STRING.SEARCH_N_FILTER}</span>
                    </NavLink>
                </li>
                {window.sessionStorage.getItem('searchType') !== 'across' && window.sessionStorage.getItem('searchType') !== 'project' ?
                    <>
                        <Tooltip title={STRING.INSIGHTS + ' - ' + STRING.COMING_SOON} placement="bottom" arrow>
                            <li>
                                <NavLink className="main-side-a pointer-event-none" exact={true} activeClassName="kognetics-actice-class" to={Routes.INSIGHTS} onClick={e => showPage(e, STRING.INSIGHTS)}>
                                    <i className={"fa mr-25px " + (ICONS.INSIGHTS)} />
                                    <span className="side-nav-text">{STRING.INSIGHTS}</span>
                                </NavLink>
                            </li>
                        </Tooltip>
                        <Tooltip title={STRING.MY_LIST + ' - ' + STRING.COMING_SOON} placement="bottom" arrow>
                            <li>
                                <NavLink className="main-side-a pointer-event-none" exact={true} activeClassName="kognetics-actice-class" to={Routes.MY_LIST} onClick={e => showPage(e, STRING.MY_LIST)}>
                                    <i className={"fa mr-25px " + (ICONS.MY_LIST)} />
                                    <span className="side-nav-text">{STRING.MY_LIST}</span>
                                </NavLink>
                            </li>
                        </Tooltip>
                        <Tooltip title={STRING.MY_SAVED_SEARCH + ' - ' + STRING.COMING_SOON} placement="bottom" arrow>
                            <li>
                                <NavLink className="main-side-a pointer-event-none" exact={true} activeClassName="kognetics-actice-class" to={Routes.MY_SAVED_SEARCH} onClick={e => showPage(e, STRING.MY_SAVED_SEARCH)}>
                                    <i className={"fa mr-25px " + (ICONS.MY_SAVED_SEARCH)} />
                                    <span className="side-nav-text">{STRING.MY_SAVED_SEARCH}</span>
                                </NavLink>
                            </li>
                        </Tooltip>
                        <Tooltip title={STRING.MY_PREFERENCES + ' - ' + STRING.COMING_SOON} placement="bottom" arrow>
                            <li>
                                <NavLink className="main-side-a pointer-event-none" exact={true} activeClassName="kognetics-actice-class" to={Routes.MY_PREFERENCES} onClick={e => showPage(e, STRING.MY_PREFERENCES)}>
                                    <i className={"fa mr-25px " + (ICONS.MY_PREFERENCES)} />
                                    <span className="side-nav-text">{STRING.MY_PREFERENCES}</span>
                                </NavLink>
                            </li>
                        </Tooltip>



                        {/* <li>
                    <NavLink className="main-side-a" exact={true} activeClassName="kognetics-actice-class" to={Routes.MY_KOGNETICS} onClick={e => showPage(e, STRING.MY_KOGNETICS)}>
                        <i className={"fa mr-25px " + (ICONS.MY_KOGNETICS)} />
                        <span className="side-nav-text">{STRING.MY_KOGNETICS}</span>
                    </NavLink>
                </li> */}
                    </>
                    : null}
            </ul>
        </div>
    </div>
);

export default SideNavigation;